module.exports = __webpack_public_path__ + "static/media/20210409_181714_753_IMG_0031.5bbbb9a1.jpg";